import { CommonMutationCrumbs } from './breadcrumb';

export const SearchPersonRegistrationWidowhoodCrumbs = [
  ...CommonMutationCrumbs,
  {
    name: 'Ricerca persona - Registrazione Vedovanza',
    path: '/mutazioni/persona/vedovanza',
  },
];

export const RegistrationWidowhoodCrumbs = [
  ...SearchPersonRegistrationWidowhoodCrumbs,
  {
    name: 'Registrazione Vedovanza',
    path: '/mutazioni/persona/vedovanza/registrazione',
  },
];
